var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshCcw01 = function SvgRefreshCcw01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.685 20.83a8.6 8.6 0 0 1-2.697-1.818 8.6 8.6 0 0 1-1.819-2.697A8.3 8.3 0 0 1 3.5 13H5q0 2.925 2.037 4.963Q9.076 20 12 20t4.962-2.037T19 13t-2.038-4.962T12 6h-.265l1.588 1.589-1.054 1.084-3.423-3.432 3.443-3.433 1.053 1.084L11.735 4.5H12q1.77 0 3.315.67a8.6 8.6 0 0 1 2.697 1.819 8.6 8.6 0 0 1 1.819 2.696Q20.5 11.23 20.5 13q0 1.77-.67 3.315a8.6 8.6 0 0 1-1.818 2.697 8.6 8.6 0 0 1-2.697 1.819A8.3 8.3 0 0 1 12 21.5a8.3 8.3 0 0 1-3.315-.67"
  })));
};
export default SvgRefreshCcw01;